export const FETCHROCKETS = 'space/rocket/FETCHROCKETS';
export const BOOKROCKET = 'space/rocket/BOOKROCKET';
export const CANCELBOOKING = 'space/rocket/CANCELBOOKING';
export const ADDROCKETNAME = 'space/rocket/ADDROCKETNAME';
